import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { OptionTranslateService } from '../../../../../shared/services/option-translate.service';
import { FormsModule, NgModel } from '@angular/forms';
import { SharedService } from '../../../../../shared/services/shared.service';
import { DatePipe, NgClass } from '@angular/common';

@Component({
  selector: 'app-membership-owner',
  imports: [TranslateModule, FormsModule, NgClass],
  templateUrl: './membership-owner.component.html',
  styleUrl: './membership-owner.component.css'
})
export class MembershipOwnerComponent {
  @Input() owner: any;
  @Input() showAction: boolean = true;
  @Output() onActionClick = new EventEmitter<any>();

  isEditingSignatory: boolean = false;
  lang: string = "en";
  // This method is used to initialize the class instance using option translate service and shared service
  constructor(
    private optionTranslateService: OptionTranslateService,
    private sharedService: SharedService
  ) {
    this.lang = this.sharedService.getCurrentLang() || 'en';
  }

  // This method is used to edit detail using owner
  editDetail(owner: any) {
    this.onActionClick.emit({ "data": owner, type: "edit" })
  }
  // This method is used to remove using owner
  remove(owner: any) {
    this.onActionClick.emit({ "data": owner, type: "remove" })
  }
  // This method is used to activate using owner
  activate(owner: any) {
    this.onActionClick.emit({ "data": owner, type: "activate" })
  }
  // This method is used to get lookups names using lookup name and key value
  getLookupsNames(lookupName: any, keyValue: any) {
    let nationalities = this.optionTranslateService.getOptions(
      'nationalities', this.lang
    );
    let roles = this.optionTranslateService.getOptions('roles', this.lang);

    let masterData: any = lookupName == 'nationalities' ? nationalities : roles;
    if (typeof (keyValue) == 'object' && keyValue) {
      return masterData
        .filter((l: any) => keyValue.includes(l.value))
        .map((l: any) => l.label);
    } else {
      return masterData
        .filter((l: any) => keyValue == l.value)
        .map((l: any) => l.label);
    }
  }

  // This method is used to update owner action using owner
  updateOwnerAction(owner: any) {
    this.onActionClick.emit({ "data": owner, type: "update-action" });
    this.isEditingSignatory = false;
  }
  get iconPath(): string {
    if (this.owner?.isError) {
      return '/icons/svg/warning.svg';
    }
    if (this.owner?.endDate) {
      return '/icons/svg/pending.svg';
    }
    return '/icons/svg/card-success.svg';
  }
}

